export default __webpack_public_path__ + "static/131-b27efc102468bec134eab16133f2ae70.jpg";